import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { hiddenMixin } from '../common/styled';
export var ScreenReaderText = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), hiddenMixin);